const faqs = [
  {
    question: "Hoe bereken je een cijfer?",
    answer:
      "Vul je behaalde score en de maximale score in. De calculator berekent automatisch je cijfer op basis van de ingestelde cesuur en N-term.",
  },
  {
    question: "Hoe werkt normering bij een toets of examen?",
    answer:
      "Bij normering wordt de N-term toegepast om de zwaarte van een toets te compenseren. Een hogere N-term maakt de toets makkelijker doordat je met dezelfde score een hoger cijfer krijgt.",
  },
  {
    question: "Wat is een cesuur en hoe gebruik je die?",
    answer:
      "De cesuur is het percentage van de maximale score dat je nodig hebt voor een voldoende. Bij 50% cesuur heb je de helft van de punten nodig voor een 5,5.",
  },
  {
    question: "Hoe bereken je een cijfer met percentages?",
    answer:
      "Stel de cesuur in als percentage. Dit bepaalt hoeveel procent van de maximale score nodig is voor een voldoende cijfer.",
  },
  {
    question: "Welk cijfer moet ik halen voor een voldoende?",
    answer:
      "Gebruik de 'Cijfer naar Score' functie bovenaan de pagina. Vul je gewenste cijfer in en zie direct welke score je minimaal nodig hebt.",
  },
];

export { faqs };

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": ["SoftwareApplication", "WebApplication"],
  name: "Cijfer berekenen",
  applicationCategory: "EducationalApplication",
  operatingSystem: "Any",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "EUR",
  },
  inLanguage: "nl-NL",
  description:
    "Gratis online cijfercalculator voor het berekenen van toets- en examencijfers met cesuur, N-term normering en percentages.",
  url: "https://www.berekencijfers.nl",
  browserRequirements: "Requires JavaScript",
  softwareVersion: "1.0",
  featureList: [
    "Score naar cijfer berekening",
    "Cijfer naar score lookup",
    "Volledige cijfertabel generatie",
    "N-term normering",
    "Cesuur percentage instelling",
    "CSV export",
    "Kopieer naar klembord",
    "URL parameters voor delen",
  ],
  educationalUse: ["Beoordeling", "Toetsing", "Examinering"],
  audience: {
    "@type": "EducationalAudience",
    educationalRole: ["teacher", "student"],
  },
  potentialAction: {
    "@type": "UseAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate:
        "https://www.berekencijfers.nl/?passingGrade={passingGrade}&maxScore={maxScore}&term={term}&linearPercentage={linearPercentage}&pointsType={pointsType}",
      actionPlatform: [
        "https://schema.org/DesktopWebPlatform",
        "https://schema.org/MobileWebPlatform",
      ],
    },
    "target-input": [
      {
        "@type": "PropertyValueSpecification",
        valueName: "passingGrade",
        valueRequired: false,
        defaultValue: "5.5",
        description: "Minimum passing grade (5.0, 5.5, or 6.0)",
      },
      {
        "@type": "PropertyValueSpecification",
        valueName: "maxScore",
        valueRequired: false,
        defaultValue: "50",
        description: "Maximum achievable score (1-300)",
      },
      {
        "@type": "PropertyValueSpecification",
        valueName: "term",
        valueRequired: false,
        defaultValue: "100",
        description: "N-term value for difficulty adjustment (0-200)",
      },
      {
        "@type": "PropertyValueSpecification",
        valueName: "linearPercentage",
        valueRequired: false,
        defaultValue: "50",
        description: "Cesuur percentage (0-100)",
      },
      {
        "@type": "PropertyValueSpecification",
        valueName: "pointsType",
        valueRequired: false,
        defaultValue: "full",
        description: "Points distribution (full, half, quarter, tenth)",
      },
    ],
  },
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

export default function JsonLd() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(softwareApplicationSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqPageSchema),
        }}
      />
    </>
  );
}
